



import React, { useEffect, useRef, useState } from "react";
import { X, Camera, RotateCcw, Check, Loader2 } from "lucide-react";
import { punchInApi, punchOutApi } from "../app/api";
import { notifyPunchedIn } from "../utils/usePunchReminder";

export default function CameraModal({
  mode,
  location,
  onClose,
  loadAttendance,
  onPunchSuccess,
}) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  const [ready, setReady] = useState(false);
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    startCamera();
    return stopCamera;
  }, []);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
      });
      streamRef.current = stream;
      videoRef.current.srcObject = stream;
      videoRef.current.onloadedmetadata = () => {
        videoRef.current.play();
        setReady(true);
      };



      // if (videoRef.current) {
      //   videoRef.current.srcObject = stream;
      
      //   try {
      //     await videoRef.current.play();
      //     setReady(true);
      //   } catch (err) {
      //     console.log("Play failed:", err);
      //   }
      // }




    } catch {
      alert("Camera access denied");
      onClose();
    }
  };

  const stopCamera = () => {
    streamRef.current?.getTracks().forEach(t => t.stop());
  };

  // const capture = () => {
  //   const canvas = canvasRef.current;
  //   const video = videoRef.current;
  //   canvas.width = video.videoWidth;
  //   canvas.height = video.videoHeight;
  //   canvas.getContext("2d").drawImage(video, 0, 0);

  //   canvas.toBlob(blob => {
  //     const f = new File([blob], "punch.png", { type: "image/png" });
  //     setFile(f);
  //     setPreview(URL.createObjectURL(f));
  //     stopCamera();
  //   });
  // };




  const capture = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
  
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
  
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);
  
    // Convert to WEBP instead of PNG
    canvas.toBlob(
      (blob) => {
        const f = new File([blob], "punch.webp", { type: "image/webp" });
        setFile(f);
        setPreview(URL.createObjectURL(f));
        stopCamera();
      },
      "image/webp",
      0.8 // Quality (0.0 - 1.0). 0.8 is good balance
    );
  };







  const submit = async () => {
    setUploading(true);
    const form = new FormData();
    form.append("image", file);
    if (location?.lat && location?.lng) {
      form.append("lat", location.lat);
      form.append("lng", location.lng);
    }

    const res =
      mode === "IN"
        ? await punchInApi(form)
        : await punchOutApi(form);

    if (!res.success) {
      alert(res.message);
      setUploading(false);
      return;
    }

    if (mode === "IN") {
      try {
        notifyPunchedIn();
      } catch (e) {
        console.warn("Could not notify service worker of punch-in:", e);
      }
    }

    onPunchSuccess?.(mode, res?.data);
    await loadAttendance();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70 backdrop-blur" />

      <div className="
        relative w-[420px] max-w-full
        bg-white/90 backdrop-blur-xl
        rounded-3xl shadow-2xl p-4
      ">
        {/* Header */}
        <div className="flex justify-between items-center mb-2">
          <h2 className="font-semibold text-lg">
            {mode === "IN" ? "Punch In" : "Punch Out"}
          </h2>
          <button onClick={onClose}><X /></button>
        </div>

        {/* Camera */}
        <div className="relative w-full h-72 rounded-2xl overflow-hidden bg-black">
          {!preview && !ready && (
            <div className="absolute inset-0 flex items-center justify-center">
              <Loader2 className="animate-spin text-white" />
            </div>
          )}

          {!preview && (
            <video
              ref={videoRef}
              autoPlay
              playsInline
              className="w-full h-full object-cover"
            />
          )}

          {preview && (
            <img src={preview} className="w-full h-full object-cover" />
          )}
        </div>

        <canvas ref={canvasRef} className="hidden" />

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-4">
          {!preview ? (
            <button
              onClick={capture}
              disabled={!ready}
              className="px-6 py-2 bg-green-600 text-white rounded-full flex items-center gap-2 hover:scale-105 transition"
            >
              <Camera size={18}/> Capture
            </button>
          ) : (
            <>
              <button
                onClick={() => {
                  setPreview(null);
                  setFile(null);
                  startCamera();
                }}
                className="px-4 py-2 bg-gray-500 text-white rounded-full flex items-center gap-2"
              >
                <RotateCcw size={16}/> Retake
              </button>

              <button
                onClick={submit}
                disabled={uploading}
                className="px-6 py-2 bg-blue-600 text-white rounded-full flex items-center gap-2 hover:scale-105 transition"
              >
                {uploading ? "Uploading..." : <><Check size={16}/> Submit</>}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}


// import React, { useEffect, useRef, useState } from "react";
// import { X, Camera, RotateCcw, Check, Loader2 } from "lucide-react";
// import { punchInApi, punchOutApi } from "../app/api";

// export default function CameraModal({
//   mode,
//   location,
//   onClose,
//   loadAttendance,
//   onGeoError,
// }) {
//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const streamRef = useRef(null);

//   const [ready, setReady] = useState(false);
//   const [preview, setPreview] = useState(null);
//   const [file, setFile] = useState(null);
//   const [uploading, setUploading] = useState(false);

//   useEffect(() => {
//     startCamera();
//     return stopCamera;
//   }, []);

//   const startCamera = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: { facingMode: "user" },
//       });
//       streamRef.current = stream;
//       videoRef.current.srcObject = stream;
//       videoRef.current.onloadedmetadata = () => {
//         videoRef.current.play();
//         setReady(true);
//       };



//       // if (videoRef.current) {
//       //   videoRef.current.srcObject = stream;
      
//       //   try {
//       //     await videoRef.current.play();
//       //     setReady(true);
//       //   } catch (err) {
//       //     console.log("Play failed:", err);
//       //   }
//       // }




//     } catch {
//       alert("Camera access denied");
//       onClose();
//     }
//   };

//   const stopCamera = () => {
//     streamRef.current?.getTracks().forEach(t => t.stop());
//   };

//   const capture = () => {
//     const canvas = canvasRef.current;
//     const video = videoRef.current;
//     canvas.width = video.videoWidth;
//     canvas.height = video.videoHeight;
//     canvas.getContext("2d").drawImage(video, 0, 0);

//     canvas.toBlob(blob => {
//       const f = new File([blob], "punch.png", { type: "image/png" });
//       setFile(f);
//       setPreview(URL.createObjectURL(f));
//       stopCamera();
//     });
//   };

//   const submit = async () => {
//     if (!location?.lat) {
//       onGeoError("Location missing");
//       return;
//     }

//     setUploading(true);
//     const form = new FormData();
//     form.append("image", file);
//     form.append("lat", location.lat);
//     form.append("lng", location.lng);

//     const res =
//       mode === "IN"
//         ? await punchInApi(form)
//         : await punchOutApi(form);

//     if (!res.success) {
//       alert(res.message);
//       setUploading(false);
//       return;
//     }

//     await loadAttendance();
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center">
//       <div className="absolute inset-0 bg-black/70 backdrop-blur" />

//       <div className="
//         relative w-[420px] max-w-full
//         bg-white/90 backdrop-blur-xl
//         rounded-3xl shadow-2xl p-4
//       ">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-2">
//           <h2 className="font-semibold text-lg">
//             {mode === "IN" ? "Punch In" : "Punch Out"}
//           </h2>
//           <button onClick={onClose}><X /></button>
//         </div>

//         {/* Camera */}
//         <div className="relative w-full h-72 rounded-2xl overflow-hidden bg-black">
//           {!preview && !ready && (
//             <div className="absolute inset-0 flex items-center justify-center">
//               <Loader2 className="animate-spin text-white" />
//             </div>
//           )}

//           {!preview && (
//             <video
//               ref={videoRef}
//               autoPlay
//               playsInline
//               className="w-full h-full object-cover"
//             />
//           )}

//           {preview && (
//             <img src={preview} className="w-full h-full object-cover" />
//           )}
//         </div>

//         <canvas ref={canvasRef} className="hidden" />

//         {/* Buttons */}
//         <div className="flex justify-center gap-4 mt-4">
//           {!preview ? (
//             <button
//               onClick={capture}
//               disabled={!ready}
//               className="px-6 py-2 bg-green-600 text-white rounded-full flex items-center gap-2 hover:scale-105 transition"
//             >
//               <Camera size={18}/> Capture
//             </button>
//           ) : (
//             <>
//               <button
//                 onClick={() => {
//                   setPreview(null);
//                   setFile(null);
//                   startCamera();
//                 }}
//                 className="px-4 py-2 bg-gray-500 text-white rounded-full flex items-center gap-2"
//               >
//                 <RotateCcw size={16}/> Retake
//               </button>

//               <button
//                 onClick={submit}
//                 disabled={uploading}
//                 className="px-6 py-2 bg-blue-600 text-white rounded-full flex items-center gap-2 hover:scale-105 transition"
//               >
//                 {uploading ? "Uploading..." : <><Check size={16}/> Submit</>}
//               </button>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
